export const YOUTUBE_VIDEO_URL_FORMAT = 'www.youtube.com/embed';
export const VIMEO_VIDEO_URL_FORMAT = 'player.vimeo.com/video';
export const KATSOMO_VIDEO_URL_FORMAT = 'https://www.katsomo.fi/multimedia/verkostoplayer/player.html?assetId=';

export const CAMPAIGN_CALCULATOR_FORM = 'campaignCalculatorForm';

export const LINK_DISABLED = 'link_disabled';
